<template>
  <b-form class="mt-3">
    <b-row>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[1]" />
      </b-col>
    </b-row>

    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        @click="onSearchBtnClicked"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";

import InputFilter from "../../../filters/components/InputFilter.vue";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    InputFilter,
  },
  props: {},
  setup(props) {
    const searchList = [
      {
        id: "text",
        label: "ชื่อบริษัท",
        value: "",
        class: "",
        style: "",
        placeholder: "ชื่อบริษัท",
        type: "text",
        options: [],
      },
      {
        id: "branch",
        label: "ชื่อสาขา",
        value: "",
        class: "",
        style: "",
        placeholder: "ชื่อสาขา",
        type: "text",
        options: [],
      },
    ];
    return {
      search: searchList,
      props,
    };
  },
  methods: {
    onResetBtnClicked() {
      this.search[0].value = null;
      this.search[1].value = null;
    },
    onSearchBtnClicked() {
      const params = {
        text: this.search[0].value,
        branch: this.search[1].value,
      };
      this.$emit("handleSubmit", params);
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
